import andreReview from '../media/img/reviews/andre-linked-in-review.png';
import creefordReview from '../media/img/reviews/creeford-linked-in-review.png';
import gurpreetReview from '../media/img/reviews/gurpreet-linked-in-review.png';
import samReview from '../media/img/reviews/sam-linked-in-review.png';
import navjotReview from '../media/img/reviews/navjot-linked-in-review.png';

class Link {
    #linkName = '';
    #linkUrl = '';
    constructor(name, url) {
      this.linkName = name;
      this.linkUrl = url;
    }
    set linkName(name) {
      this.#linkName = name;
    }
    set linkUrl(url) {
      this.#linkUrl = url;
    }
    get linkName() {
      return this.#linkName;
    }
    get linkUrl() {
      return this.#linkUrl;
    }
  }
  class ProfileObj{
    #profilePhoto;
    #name = '';
    #linkedInUrl = '';
    #review = '';
    constructor(photo, name, url, review) {
      this.profilePhoto = photo;
      this.name = name;
      this.linkedInUrl = url;
      this.review = review;
    }
    set profilePhoto(photo) {
      this.#profilePhoto = photo;
    }
    set name(name) {
      this.#name = name;
    }
    set linkedInUrl(url) {
      this.#linkedInUrl = url
    }
    set review(review) {
      this.#review = review;
    }
    get profilePhoto() {
      return this.#profilePhoto
    }
    get name() {
      return this.#name
    }
    get linkedInUrl() {
      return this.#linkedInUrl;
    }
    get review() {
      return this.#review;
    }
  }
  export const recommendations = [
    new ProfileObj(
      navjotReview,
      "Navjot Kaur",
      "https://www.linkedin.com/in/navjot-kaur-chohan?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_recommendations_details%3B3%2Bj%2FdJ%2F4RYCKvRMyAm2%2F5w%3D%3D",
      "It was a pleasure to have taught Dave the React course before placing him for his work experience. As his instructor in the final course of the software developer program, I had the privilege of seeing firsthand his deep understanding of complex software development concepts. He was a truly outstanding student- eager to learn, proactive, and a genuinely cooperative team member. Beyond his technical skills, Dave's interpersonal abilities are exceptional. He is incredibly respectful and has a natural way of making everyone around him feel comfortable. During his work experience, his employer shared consistently positive feedback, highlighting his professionalism and his valuable contributions to the team's success. He is a truly great team member who actively helps his peers and elevates the entire group."
    ),
    new ProfileObj(
      gurpreetReview, 
      "Gurpreet Kaur", 
      "https://www.linkedin.com/in/gurpreetkaur-dev/", 
      "I've had the pleasure of working alongside Dave as a classmate, and I can confidently say he stands out as a natural leader and an excellent communicator. He approaches people with ease and engages in meaningful conversations that make everyone feel included and valued. His ability to confidently manage workloads, set things up from scratch, and support others in understanding complex concepts is truly impressive. Whether it's a class project or a creative challenge, he brings fresh ideas and genuine enthusiasm to the table. Always eager to learn and driven to build something meaningful, he’s the kind of teammate any team would be lucky to have."
      ),
    new ProfileObj(
      samReview, 
      "Sam Ruetcky", 
      "https://www.linkedin.com/in/samuel-reutcky/", 
      "I had the pleasure of studying and working on several group projects with Dave at MITT. Dave is a reliable and collaborative teammate who always brought great ideas and a strong work ethic to the table. He’s great at problem-solving, communicates clearly, and was always willing to support others when needed. I’d happily work with him again and recommend him to any team looking for someone dependable and skilled."
      ),
    new ProfileObj(
      creefordReview, 
      "Creeford Sanchez", 
      "https://www.linkedin.com/in/creewrk?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_recommendations_details%3B3%2Bj%2FdJ%2F4RYCKvRMyAm2%2F5w%3D%3D", 
      "Collaborating with David on many projects has been both enjoyable and rewarding. I aspire to be like David, as he possesses excellent communication skills and is a natural-born team leader among the students. He is highly motivated in the field of software development, actively participating in various events and competitions to showcase and improve his skills. His ability to deliver high-quality work and his strong communication skills would make him an excellent addition to any team."),
    new ProfileObj(
      andreReview, 
      "Andre Specht", 
      "https://www.linkedin.com/in/mrspecht?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_recommendations_details%3B3%2Bj%2FdJ%2F4RYCKvRMyAm2%2F5w%3D%3D", 
      "David stood out as one of the strongest students in my class. He approached every project with focus and creativity, always pushing himself to learn more and improve his work. What impressed me most was his willingness to go beyond the lessons and explore new ideas on his own. David is also reliable, easy to work with, and brings a positive attitude to any team. I’m confident he’ll be a valuable addition wherever he goes."),
  ];
  export const collaboratorList = [
    new Link("Gurpreet Kaur", "https://www.linkedin.com/in/gurpreetkaur-dev/"),
    new Link("Sam Ruetcky", "https://www.linkedin.com/in/samuel-reutcky/"),
    new Link("Myles Reid", "https://www.linkedin.com/in/mylesreid/"),
    new Link("Michael Shuaibu", "https://www.linkedin.com/in/oluwajuwon-shuaibu/")
  ];

  export const learningCertificates = [
    new Link("Advanced AI Prompt Engineering Techniques", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_Advanced%20Prompt%20Engineering%20Techniques.pdf#toolbar=0&navpanes=0"),
    new Link("Cert Prep: Scrum Master", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_Cert%20Prep%20Scrum%20Master.pdf#toolbar=0&navpanes=0"),
    new Link("Microsoft Power Platform Fundamentals", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_Microsoft%20Power%20Platform%20Fundamentals%20PL900%20Exam%20Tips.pdf#toolbar=0&navpanes=0"),
    new Link("React Essentials Training", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_React%20Essential%20Training.pdf#toolbar=0&navpanes=0"),
    new Link("Scrum Advanced", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_Scrum%20Advanced.pdf#toolbar=0&navpanes=0"),
    new Link("SEO Foundations", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_SEO%20Foundations.pdf#toolbar=0&navpanes=0"),
    new Link("SharePoint Essential Training: Beyond the Basics", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_Sharepoint%20Online%20Essential%20Training%20Beyond%20the%20Basics.pdf#toolbar=0&navpanes=0"),
    new Link("SharePoint Essential Training: The Basics", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_SharePoint%20Online%20Essential%20Training%20The%20Basics.pdf#toolbar=0&navpanes=0"),
    new Link("Web Accessibility for Developers", "https://dave-sommerville.github.io/ds-code-releases/data/CertificateOfCompletion_Web%20Accessibility%20for%20Developers.pdf#toolbar=0&navpanes=0")
  ];

  export const ProfileObject = {
    profileImgUrl: "https://dave-sommerville.github.io/ds-code-releases/img/profile.JPG",
    imgNameOne: "Profile Image",
    paragraphOne: "I was introduced to the internet in the final years of the 1990s, back when the internet screamed. The web back then was clumsy, quirky, and a little cringey; let's simply say I could relate. Those early days shaped me into the person I am today and the internet has shaped the world as we know it.",
    paragraphTwo: "As a Software Development graduate from Manitoba Institute of Trades and Technology, I have learned the tools to shape the internet myself. From sleek front-end design to robust data structures and innovative software, I've gained a wealth of knowledge. While I'm new to the field, I've been busy putting that knowledge to use.",
    paragraphThree: "I've built a strong foundation and a growing portfolio that reflects my dedication and progress. In addition to my skills with coding and design, I bring creativity, a strong work ethic, and a knack for unique problem-solving to every project I take on. My diverse history empowers me to quickly learn and adapt to any problem or position. I am currently open and seeking work, however I'm also interested in inspiration or collaboration.",
    articleTwoImgUrl: "https://dave-sommerville.github.io/ds-code-releases/img/Opal-and-Onyx-preview.jpg",
    imgNameTwo: "Opal and Onyx preview",
    articleThreeImgUrl: "https://dave-sommerville.github.io/ds-code-releases/img/blackjack-preview-start.jpg",
    imgNameThree: "Blackjack preview",
    gitProfile: new Link("Github Profile", ""),
    gitRepos: new Link("GitHub Repositories",""),
    linkedIn: new Link("LinkedIn","https://www.linkedin.com/in/dave-sommerville-2abb50326"),
    youTube: new Link("YouTube",""),
    certificates: learningCertificates,
    resume: "https://dave-sommerville.github.io/ds-code-releases/data/Dave-Sommerville-Resume-2025-Developer-Programmer-Designer-WinnipegMB.pdf"
  }
